import { OrderSettingsToggles } from '@src/containers/Blotters/Orders/OrderSettingsToggles';
import { FormControlSizes } from '@talos/kyoko';
import type { SetStateAction } from 'react';
import type { BlotterTableOrderFilter } from '../../../../Blotters/Orders/useOrderFilter';
import { MobileCompactCardsToggle } from '../MobileCompactCardsToggle';

interface MobileOrderSettingsTogglesProps {
  filter: BlotterTableOrderFilter;
  changeFilter: (action: SetStateAction<BlotterTableOrderFilter>) => void;
  showAPIOrdersToggle?: boolean;
  alwaysShowDDHOrders?: boolean;
}

export function MobileOrderSettingsToggles({
  filter,
  changeFilter,
  showAPIOrdersToggle = true,
  alwaysShowDDHOrders,
}: MobileOrderSettingsTogglesProps) {
  return (
    <>
      <MobileCompactCardsToggle type="Order" />
      <OrderSettingsToggles
        filter={filter}
        changeFilter={changeFilter}
        showAPIOrdersToggle={showAPIOrdersToggle}
        alwaysShowDDHOrders={alwaysShowDDHOrders}
        size={FormControlSizes.Default}
        fullWidth
      />
    </>
  );
}
